import { MakeCall } from 'ha/services/apiV2/createMakeCall';

type Payload = { payoutMethodId: string; listings: number[] };

const updatePayoutMethodRouting = (makeCall: MakeCall) => (
  userId: number,
  data: Payload,
) =>
  makeCall<void>('POST', `/v1/user/${userId}/payout-routing/link`, {
    data: {
      payoutMethodGuid: data.payoutMethodId,
      listings: data.listings,
    },
  });

export default updatePayoutMethodRouting;
